import React from 'react'
import img1 from "../../../Assets/blogDetails/blogImage.png"
import img2 from "../../../Assets/blogDetails/calender.svg"
import img3 from "../../../Assets/blogDetails/eye.svg"
function BlogImage() {
  return (
    <div className="">
      <div className="flex items-center justify-center ">
        <img src={img1} alt="blog image" className=" rounded-lg " />
      </div>
      <div className="flex sm:flex-row flex-col sm:gap-0 gap-5 justify-between items-center sm:px-16 p-6">
        <div className="flex gap-2 items-center">
          <img src={img2} alt="calender" className="h-5 w-5" />
          <h1>20-12-2024</h1>
        </div>
        <div className="flex items-center gap-5">
          <div className="border px-3 py-2 rounded-full border-gray-500">
            <h1>Bhubaneswar</h1>
          </div>
          <div className="flex items-center gap-2 border px-3 py-2 rounded-full border-gray-500">
            <img src={img3} alt="eye" />
            <h1>16 Views</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogImage
